import React from 'react';

import MultiLingualContent from "../config/multilingualContent";
import '../assets/css/loading.css'


function Loading() {

    return (
        <div className="loading-container">
          <span className="loading-placeholder"></span>
        </div>
    );

}


export default Loading;